import React, { Fragment, useEffect, useState } from "react";
import FullScreenImage from "./FullScreenImage";
import SelectedImages from "./SelectedImages";
import { chatSelector, globalStateSelector } from "../../../../../store/selector";
import { connect } from "react-redux";
import "./ImagePicker.css";
import MessageScreenFooter from "../MessageScreenFooter/MessageScreenFooter";
import { chatAction, messageAction } from "../../../../../store/action";
import APIManager from "modules/common/apiManager";
import { changeLastMessage } from "../../../../../dialpad/service/chat.service";
import { getTime, getUUID } from "../../utils";
import { createChatEvent } from "../../../../../dialpad/service/chat.service";
import Header from "./Header";

const mAPI = new APIManager();

const ImagePicker = ({ selectedImages: selectedImagesFromRedux, ...props }) => {
  console.log("asdlfkjvn ", { selectedImagesFromRedux });
  const [SelectedAllImages, setSelectedAllImages] = useState([]);
  const [selectedImages, setSelectedImages] = useState([]);
  const [fullScreenImage, setFullScreenImage] = useState(null);
  const [fullScreenImgUrl, setfullScreenImgUrl] = useState(null);
  const [currImgIndex, setCurrImgIndex] = useState(0);
  const [CustomMessage, setCustomMessage] = useState("");
  const handleImageSelect = (image) => {
    setSelectedImages((prevSelected) => [...prevSelected, image]);
  };

  useEffect(() => {
    console.log("Here is also message ", CustomMessage);
  }, [CustomMessage]);

  useEffect(() => {
    console.log("asdlfkjvn ", { selectedImages });
  }, [selectedImages]);

  useEffect(() => {
    console.log(
      SelectedAllImages,
      "this is selectedAllimages",
      SelectedAllImages[currImgIndex]
    );
  }, [SelectedAllImages]);

  useEffect(() => {
    console.log("this is selectedAllimages2", currImgIndex);
  }, [currImgIndex]);
  useEffect(() => {
    if (selectedImagesFromRedux && selectedImagesFromRedux.length > 0) {
      let urlArr = [];
      let fileArr = [];
      Array.from(selectedImagesFromRedux).forEach((file) =>
        urlArr.push(URL.createObjectURL(file))
      );
      Array.from(selectedImagesFromRedux).forEach((file) => fileArr.push(file));
      setSelectedAllImages(fileArr);
      setfullScreenImgUrl(urlArr[0]);
      setSelectedImages(urlArr);
    }
  }, [selectedImagesFromRedux]);

  const handleImageRemove = (index) => {
    setSelectedImages((prevSelected) =>
      prevSelected.filter((_, i) => i !== index)
    );
  };

  const handleFullScreenImageClick = (image) => {
    // setFullScreenImage(image);
    setfullScreenImgUrl(image);
  };

  const nextImage = () => {
    const nextIndex = currImgIndex + 1;
    if (nextIndex < selectedImages.length) {
      setfullScreenImgUrl(selectedImages[nextIndex]);
      setCurrImgIndex(nextIndex);
    }
  };
  const prevImage = () => {
    const prevIndex = currImgIndex - 1;
    if (prevIndex >= 0) {
      setfullScreenImgUrl(selectedImages[prevIndex]);
      setCurrImgIndex(prevIndex);
    }
  };

  const selectImage = (index) => {
    if (index >= 0 && index < selectedImages.length) {
      setfullScreenImgUrl(selectedImages[index]);
      setCurrImgIndex(index);
    }
  };

  const getPublicUrl = (formData, uniqueId) => {
    const event = createChatEvent({ id: uniqueId, loading: 0 });
    const {
      retryImages,
      dynamicUpdate,
      messageList,
      selectedAssignedList,
    } = props;
    window.dispatchEvent(event);
    return new Promise((res, rej) => {
      mAPI.sendPostForm(
        `chat/upload`,
        formData,
        (data) => {
          res(data);
        },
        (errorCode, data) => {
          const event = createChatEvent({ id: uniqueId, success: false });
          window.dispatchEvent(event);
          dynamicUpdate({
            data: {
              key: `messageList.${selectedAssignedList.identifier}`,
              value: [
                ...messageList[`${selectedAssignedList.identifier}`].map(
                  (d) => {
                    if (d.id === uniqueId) {
                      return {
                        ...d,
                        error: true,
                        content: {
                          ...d.content,
                          file: selectedImagesFromRedux[0],
                        },
                      };
                    }
                    return d;
                  }
                ),
              ],
            },
          });
        },
        "private",
        (data) => {
          const progress = Math.round((100 * data.loaded) / data.total);
          const event = createChatEvent({ id: uniqueId, loading: progress });
          window.dispatchEvent(event);
        }
      );
    });
  };

  const resetState = () => {
    const { dynamicUpdate } = props;
    setSelectedImages([]);
    setfullScreenImgUrl(null);
    setCurrImgIndex(0);
    dynamicUpdate({ data: { key: `selectedImages`, value: [] } });
  };

  const sendMessage = async (e) => {
    const uniqueId = getUUID();
    const {
      configProcessor,
      messageList,
      assignedList,
      selectedAssignedList,
      dynamicUpdate,
      currentUser
    } = props;
    const mimeType = selectedImagesFromRedux[0].type;
    const commonPayload = {
      from: "agent",
      timeStamp: new Date().toISOString(),
      type: "image",
      content: {
        link: URL.createObjectURL(selectedImagesFromRedux[0]),
        mimeType: mimeType,
        caption: CustomMessage,
      },
      id: uniqueId,
      loading: 0,
    };
    const messageData = {
      userId: currentUser.userId,
      timeStamp: new Date().toISOString(),
      agent: {
        email: currentUser.email,
        name: currentUser.name,
        role: currentUser.role,
        userId: currentUser.userId,
        username: currentUser.user_name,
      },
      message: commonPayload,
    };
    dynamicUpdate({
      data: {
        key: `messageList.${selectedAssignedList.identifier}`,
        value: [
          messageData,
          ...(messageList[selectedAssignedList.identifier] || []),
        ],
      },
    });
    resetState();
    const formData = new FormData();
    formData.append("file", selectedImagesFromRedux[0]);
    const data = await getPublicUrl(
      formData,
      uniqueId,
      selectedAssignedList.identifier
    );
    console.log({ data });
    const messagePayload = {
      ...commonPayload,
      content: {
        ...data,
        mimeType: mimeType,
        caption: CustomMessage,
      },
    };
    configProcessor("sendPayload", {
      ...selectedAssignedList,
      payloadType: "message",
      "rmq:pattern": "agent:message",
      message: {
        ...(selectedAssignedList && selectedAssignedList.message),
        ...messagePayload,
      },
    });

    changeLastMessage({
      list: assignedList,
      identifier: selectedAssignedList.identifier,
      receivedMessage: messagePayload,
      key: "assignedList",
    });
  };

  const removeSelectedImage = (evt) => {
    if (evt.key === "Escape") {
      if (selectedImages.length) {
        resetState();
      }
    }
  };
  function closeFullScreen() {
    setfullScreenImgUrl(null);
  }

  useEffect(() => {
    window.addEventListener("keydown", removeSelectedImage);

    return () => {
      window.removeEventListener("keydown", removeSelectedImage);
    };
  }, [removeSelectedImage]);

  return (
    <Fragment>
      {fullScreenImgUrl && (
        <div className="image-picker__main">
          {/* <div className="document-picker_header">
            <Header
              name={
                (SelectedAllImages &&
                  SelectedAllImages[currImgIndex] &&
                  SelectedAllImages[currImgIndex].name) ||
                ""
              }
              size={
                (SelectedAllImages &&
                  SelectedAllImages[currImgIndex] &&
                  SelectedAllImages[currImgIndex].size) ||
                0
              }
              onClose={closeFullScreen}
            />
          </div> */}
          <div className="image-picker__inner">
            <Header name={SelectedAllImages && SelectedAllImages[currImgIndex] && SelectedAllImages[currImgIndex].name || ''} size={SelectedAllImages && SelectedAllImages[currImgIndex] && SelectedAllImages[currImgIndex].size || 0 } onClose={closeFullScreen}/>
            <div
              className="image-picker-body_close"
              onClick={() => closeFullScreen()}
            ></div>
            <FullScreenImage
              name={
                (SelectedAllImages &&
                  SelectedAllImages[currImgIndex] &&
                  SelectedAllImages[currImgIndex].name) ||
                ""
              }
              nextImage={nextImage}
              prevImage={prevImage}
              imageUrl={fullScreenImgUrl}
              onClose={() => setfullScreenImgUrl(null)}
            />
            {/* <Header name={SelectedAllImages && SelectedAllImages[currImgIndex] && SelectedAllImages[currImgIndex].name || ''} size={SelectedAllImages && SelectedAllImages[currImgIndex] && SelectedAllImages[currImgIndex].size || 0 } onClose={closeFullScreen}/> */}
            <SelectedImages
              selectImage={selectImage}
              selectedImages={selectedImages}
              type={"image"}
              onImageClick={handleFullScreenImageClick}
              onImageRemove={handleImageRemove}
            />
            <div className="position-absolute w-100 bottom-0">
              <MessageScreenFooter
                showAttachBtn={false}
                customSendMessage={sendMessage}
                setCustomMessage={setCustomMessage}
                setIsFileAttached={true}
              />
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
};

const stateToProps = (state) => ({
  selectedAssignedList: chatSelector.getChatDynamic(
    state,
    "selectedAssignedList"
  ),
  messageList: chatSelector.getChatDynamic(state, "messageList"),
  assignedList: chatSelector.getChatDynamic(state, "assignedList"),
  selectedImages: chatSelector.getChatDynamic(state, "selectedImages"),
  retryImages: chatSelector.getChatDynamic(state, "retryImages"),
  currentUser: globalStateSelector.getDynamic(state, { key: 'currentUser' })
});

const dispatchToProps = (dispatch) => ({
  configProcessor: (type, messageData) => {
    dispatch(messageAction.configProcessor(type, messageData));
  },
  dynamicUpdate: (type, messageData) => {
    dispatch(chatAction.dynamicUpdate(type, messageData));
  },
});
export default connect(stateToProps, dispatchToProps)(ImagePicker);



// WEBPACK FOOTER //
// src/modules/screens/chatscreen/components/ImageLibrary/ImagePicker.js